export const team = [
    {
        id: 1,
        name: "Olatunde Victor Adeoluwa",
        image: "assets/img/team/victor.jpeg",
        role: "Founder & CEO"
    },
    {
        id: 2,
        name: "Excellence Favour Oluwatobi",
        image: "assets/img/team/excellence.jpeg",
        role: "Chief Finance Officer"
    },
    {
        id: 3,
        name: "Vee Mapunde",
        image: "assets/img/team/vee.jpeg",
        role: "R&D Lead"
    },
    {
        id: 4,
        name: "Fanto Foday",
        image: "assets/img/team/fanto.jpg",
        role: "Programs Lead, Incubator"
    },
    {
        id: 5,
        name: "Oluwaseun Adepoju",
        image: "assets/img/team/oluwaseun.png",
        role: "STEAM Studies Operations Lead"
    },
    {
        id: 6,
        name: "Dr Toyosi Craig ",
        image: "assets/img/team/toyosi.png",
        role: "Renewable Energy Practice Lead"
    },
    {
        id: 7,
        name: "Olabopo Philips",
        image: "assets/img/team/olabopo.jpeg", 
        role: "Studio Lead Partner"
    },
    {
        id: 8,
        name: "Uyi Asemota",
        image: "assets/img/team/uyi.jpeg",
        role: "Food & AgriTech Practice Lead"
    },
    {
        id: 9,
        name: "Ahmed Bankole",
        image: "assets/img/team/ahmed.jpeg",
        role: "Full Stack Developer & Tech Lead"
    },
    {
        id: 10,
        name: "Trust Katsande",
        image: "assets/img/team/trust.jpeg",
        role: "Agricultural R&D and STEAM Lead"
    },
    {
        id: 11,
        name: "Abisoye Akande",
        image: "assets/img/team/abisoye.jpeg",
        role: "Finance & Investors Relations Associate "
    },
    {
        id: 12,
        name: "Adeniyi Adekunle",
        image: "assets/img/team/adeniyi.jpeg",
        role: "Media Management Associate"
    },
    {
        id: 13,
        name: "Samuel Paul",
        image: "assets/img/team/samuel.jpeg",
        role: "Branding Associate "
    }
]
